import { render } from "./B2bFiltersDeliveryNotesReceived.vue?vue&type=template&id=7e99448f&scoped=true&lang=pug"
import script from "./B2bFiltersDeliveryNotesReceived.vue?vue&type=script&lang=js"
export * from "./B2bFiltersDeliveryNotesReceived.vue?vue&type=script&lang=js"

import "./B2bFiltersDeliveryNotesReceived.vue?vue&type=style&index=0&id=7e99448f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e99448f"]])

export default __exports__